import { atom } from 'jotai';

const allMetricsAtom = atom({});
const metricOrderAtom = atom([]);
const selectedMetricsAtom = atom([]);
const anchorMetricsAtom = atom({});

const updateAnchorAtom = atom(
  null,
  (get, set, value: string) => {
    const anchors: any = get(anchorMetricsAtom);
    if (anchors[value]) {
      const updatedData: any = { ...anchors, [value]: false };
      set(anchorMetricsAtom, updatedData);
    } else {
      const updatedData: any = { ...anchors, [value]: true };
      set(anchorMetricsAtom, updatedData);
    }
  });

export {
  allMetricsAtom,
  selectedMetricsAtom,
  anchorMetricsAtom,
  updateAnchorAtom,
  metricOrderAtom,
}
